import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/global.css";

import { BrowserRouter } from "react-router-dom";
import Routes from "../src/Routes";
import DataProvider from "./services/context/DataProvider";
import { AuthProvider } from "./contexts/AuthContext";
import { AccountProvider } from "./contexts/AccountContext";
import { EntryProvider } from "./contexts/EntryContext";
import { TedProvider } from "./contexts/TedContext";
import { EcheckProvider } from "./contexts/echeckContext";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "./styles/Themes/default";
import { GlobalStyle } from "./styles/global";
import { ClientProvider } from "./contexts/ClientContext";
import { PixKeyProvider } from "./contexts/PixKeyContext";
import { ToastContainer } from "react-toastify";
import { SocketProvider } from "./contexts/SocketContext";
import { CompanyUserProvider } from "./contexts/CompanyContext";
import { LimitProvider } from "./contexts/LimitContext";
import { PayrollProvider } from "./contexts/payrollContext";

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <ToastContainer limit={2} style={{ zIndex: 9999999999 }} />
      <GlobalStyle />
      <DataProvider>
        <BrowserRouter>
          <AuthProvider>
            <SocketProvider>
              <AccountProvider>
                <CompanyUserProvider>
                  <PayrollProvider>
                    <EntryProvider>
                      <TedProvider>
                        <EcheckProvider>
                          <ClientProvider>
                            <PixKeyProvider>
                              <LimitProvider>
                                <Routes />
                              </LimitProvider>
                            </PixKeyProvider>
                          </ClientProvider>
                        </EcheckProvider>
                      </TedProvider>
                    </EntryProvider>
                  </PayrollProvider>
                </CompanyUserProvider>
              </AccountProvider>
            </SocketProvider>
          </AuthProvider>
        </BrowserRouter>
      </DataProvider>
    </ThemeProvider>
  );
}

export default App;
